import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Truck, Gift, Copy } from "lucide-react";
import api, { money } from "@/lib/api";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function ThankYou() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); api.get(`/orders/${orderId}`).then((r) => setOrder(r.data)); }, [orderId]);
  if (!order) return <div className="min-h-screen grid place-items-center text-stone-400">Loading…</div>;

  const refLink = `${window.location.origin}/?ref=${orderId.slice(0, 8)}`;
  const copy = () => { navigator.clipboard.writeText(refLink); toast.success("Referral link copied!"); };

  return (
    <div className="min-h-screen bg-stone-50">
      <header className="border-b border-stone-200 bg-white"><div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-center"><Logo className="text-2xl" /></div></header>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-8">
          <div className="w-16 h-16 mx-auto grid place-items-center rounded-full mb-4" style={{ background: "var(--mint)" }}><Check size={32} className="text-white" /></div>
          <h1 className="font-display text-4xl font-extrabold text-stone-900">Your Friib is on the way.</h1>
          <p className="text-stone-500 mt-2">We sent a confirmation to {order.email}.</p>
        </motion.div>

        <div className="rounded-3xl bg-white border border-stone-100 friib-shadow p-6 mb-6" data-testid="order-details">
          <div className="flex gap-4 pb-4 border-b border-stone-200">
            <img src={order.product_image} alt="" className="w-20 h-20 object-cover rounded-xl" />
            <div><p className="text-xs font-bold uppercase text-stone-500">Order #{orderId.slice(0, 8)}</p><p className="font-display font-bold text-stone-900">{order.product_name}</p><p className="text-sm text-stone-400">Shipping to {order.shipping_address}</p></div>
          </div>
          {order.upsells?.length > 0 && (
            <div className="py-4 border-b border-stone-200"><p className="text-xs font-bold uppercase text-stone-500 mb-2">Also added</p>
              {order.upsells.map((u) => <div key={u.id} className="flex justify-between text-sm py-0.5"><span className="text-stone-600">{u.name}</span><span className="font-semibold">{money(u.price)}</span></div>)}
            </div>
          )}
          <div className="pt-4 flex justify-between"><span className="font-bold text-stone-900">Total paid</span><span className="font-display font-extrabold text-xl">{money(order.total)}</span></div>
          <p className="mt-4 flex items-center gap-2 text-sm text-stone-500"><Truck size={16} style={{ color: "var(--friib)" }} /> Estimated delivery: 5–8 business days</p>
        </div>

        <div className="rounded-3xl p-6 text-white mb-6" style={{ background: "var(--ink)" }}>
          <div className="flex items-center gap-2 mb-2"><Gift size={20} style={{ color: "var(--friib)" }} /><h3 className="font-display font-bold text-lg">Give your friends Friib</h3></div>
          <p className="text-stone-300 text-sm mb-4">Share your link and help a friend discover their next favorite.</p>
          <div className="flex gap-2">
            <input readOnly value={refLink} className="flex-1 px-4 py-2.5 rounded-full text-stone-900 text-sm" data-testid="referral-link" />
            <button onClick={copy} className="px-4 py-2.5 rounded-full font-bold text-white flex items-center gap-1.5" style={{ background: "var(--friib)" }}><Copy size={15} /> Copy</button>
          </div>
        </div>

        <div className="flex gap-3">
          <Link to="/shop" className="flex-1 text-center py-3.5 rounded-full font-bold text-white" style={{ background: "var(--friib)" }}>Shop more Friibs</Link>
          <Link to="/account" className="flex-1 text-center py-3.5 rounded-full font-bold text-stone-900 bg-white friib-shadow">View my Friibs</Link>
        </div>
      </div>
    </div>
  );
}
